// extracted by mini-css-extract-plugin
module.exports = {"Container":"FocusInputs_Container__Lx8U2","CurrentTimeLabel":"FocusInputs_CurrentTimeLabel__Cwl4j","DurationLabel":"FocusInputs_DurationLabel__lu_wC"};